import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-green-900 py-8 text-amber-50" data-id="element-123">
      <div className="container mx-auto px-4" data-id="element-124">
        <div className="flex flex-col md:flex-row justify-between items-center mb-6" data-id="element-125">
          <div className="mb-4 md:mb-0" data-id="element-126">
            <p className="text-amber-50/80" data-id="element-127">
              Customer Service: support@snoutyco.com
            </p>
          </div>
          <div className="flex space-x-4" data-id="element-128">
            <a href="#" className="text-amber-50/80 hover:text-amber-50" data-id="element-129">
              Terms
            </a>
            <a href="#" className="text-amber-50/80 hover:text-amber-50" data-id="element-130">
              Privacy
            </a>
            <a href="#" className="text-amber-50/80 hover:text-amber-50" data-id="element-131">
              Returns
            </a>
            <a href="#" className="text-amber-50/80 hover:text-amber-50" data-id="element-132">
              Contact
            </a>
          </div>
        </div>
        <div className="border-t border-amber-50/20 pt-6 text-center text-amber-50/70 text-sm" data-id="element-133">
          <p className="mb-2" data-id="element-134">
            These statements have not been evaluated by the FDA. This product is
            not intended to diagnose, treat, cure, or prevent any disease.
            Results may vary. Always consult your veterinarian before starting
            any new supplement regimen.
          </p>
          <p data-id="element-135">© 2025 The Daily Foundation Chew. All Rights Reserved.</p>
        </div>
      </div>
    </footer>;
};